import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { queryKeys } from "@/lib/query-keys";

export interface AssetPurchaseStats {
  purchases_last_24h: number;
  purchases_last_7d: number;
  purchases_last_30d: number;
  total_purchases: number;
  total_downloads?: number;
}

export function useAssetPurchaseStats(assetId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.assets.purchaseStats(assetId || ""),
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_asset_purchase_stats", {
        p_asset_id: assetId!,
      });
      if (error) throw error;
      return data as unknown as AssetPurchaseStats;
    },
    enabled: !!assetId,
    staleTime: 5 * 60_000,
    gcTime: 15 * 60_000,
  });
}
